import React from "react";
import { usePagination, DOTS } from "./UsePagination";


const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange?.length - 1];
  return (
    <ul>

      <button onClick={onPrevious} disabled={currentPage === 1}>
        <span className="left"></span>
      </button>
      {paginationRange?.map((pageNumber,index) => {
        if (pageNumber === DOTS) {
          return <li className="pagination-item dots" key={index}>&#8230;</li>;
        }

        return (
          <li
            className={
              currentPage === pageNumber ? "active" : "paginationNumbers-number"
            }
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      <button onClick={onNext} disabled={currentPage === lastPage}>
        <span className="right"></span>
      </button>
    </ul>
  );
};

export default Pagination;
